import { render, staticRenderFns } from "./QuitModal.vue?vue&type=template&id=526be8a1&"
import script from "./QuitModal.vue?vue&type=script&lang=js&"
export * from "./QuitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports